import { atom } from 'jotai'

export type MainBottomSheet = boolean

export const INITIAL_MAIN_BOTTOMSHEET: MainBottomSheet = false
// 메인 페이지에서 최초 1회 노출할 버텀시트의 노출 여부
export const mainBottomSheetAtom = atom<MainBottomSheet>(
  INITIAL_MAIN_BOTTOMSHEET,
)
